module.exports = __webpack_public_path__ + "img/illus_tutorial_1@2x.ecff2130.png";